import { useEffect } from 'react';
import { useMinimizableModal } from '../use-minimizable-modal/index.tsx';

export const useNestedModalDetector = (): void => {
	const { setIsNestedModal } = useMinimizableModal();

	useEffect(() => {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		const modalElements: NodeListOf<Element> = document.querySelectorAll(
			'div.atlaskit-portal [aria-modal="true"]',
		);
		if (modalElements.length > 1) {
			setIsNestedModal(true);
		}
	}, [setIsNestedModal]);
};
